import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { ReportsTable } from '../../../../../../../../../../features/report/reports-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsReporting,
      label: 'Archive',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsReporting>,
  head: () => getPageHead('Report Archive'),
  component: ReportList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsReporting}
    />
  );
}

function ReportList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <ReportsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
